import type { QueryProviderProps } from "./query.type";

import { QueryClient } from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";

import { debugE2E } from "@/config/environmentUtils";

import { QueryDevTools } from "./query-dev-tools";
import { QUERY_CACHE_TIME, QUERY_PERSISTER_MAG_AGE } from "./query.constant";
import {
  createLocalStoragePersister,
  shouldDehydrateQuery,
} from "./query.helper";

/** For debug purpose in e2e tests, we should throw when an API request fail. */
const shouldTrowOnError = debugE2E();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { gcTime: QUERY_CACHE_TIME, throwOnError: shouldTrowOnError },
  },
});

const persister = createLocalStoragePersister();

export const QueryProvider = ({ children }: QueryProviderProps) => {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        maxAge: QUERY_PERSISTER_MAG_AGE,
        dehydrateOptions: { shouldDehydrateQuery },
      }}
    >
      {children}
      <QueryDevTools />
    </PersistQueryClientProvider>
  );
};
